import React from 'react';
import _ from 'lodash';
import OrganizationUnitLogoComponent from './account-logo.component';
import OrganizationUnitFavIconComponent from './account-favIcon.compoonent';

import themeData from './themes.json'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';

export const AccoutBrandInfoComponent = ({ handleFormSubmit, brandMappings, openConfirmationFav, changeFavImage, onFormFavItemChange, getIsFavRecordDeletable, deleteselectedFavIcon, getIsLogoRecordDeletable, faviconSize, openConfirmationLogo, onFormLogoItemChange, deleteselectedLogo, logoFiles, logoBackground, changeLogoImage, deleteSelectedBrands, getIsBrandRecordDeletable, onFormItemBrandChange, handleClose, handleOpen, openConfirmation, selectedBrand }: any) => {

  console.log('brandMappings in info component', brandMappings)
  return (
    <>
      {_.map(
        brandMappings,
        (selectedBrand: any, index: any) => (
          <AccordionContainer
            child={


              <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                  label="Name"
                  labelField="Name"
                  onValueChange={(event: any, newValue: any) => {
                    onFormItemBrandChange({
                      value: event.target.value,
                      field: 'Name',
                      idx: index
                    });
                  }}
                  type="text"
                  value={selectedBrand?.Name} />
                <InputContainer
                  label="Description"
                  labelField="Description"
                  onValueChange={(event: any, newValue: any) => {
                    onFormItemBrandChange({
                      value: event.target.value,
                      field: 'Description',
                      idx: index
                    });
                  }}
                  type="text"
                  value={selectedBrand?.Description} />

                {themeData && <InputContainer
                  label="Theme"
                  labelField="Text"
                  list={themeData}
                  onValueChange={(event: any, newValue: any) => {
                    onFormItemBrandChange({
                      value: event.target.value,
                      field: 'Theme',
                      idx: index
                    });
                  }}
                  optionName='Choose Theme'
                  type="select"
                  value={selectedBrand?.Theme}
                  valueField="Value"
                />}

                <div className='col-span-full'>
                  <AccordionContainer
                    child={

                      <div>
                        {_.map(
                          selectedBrand?.Logos,
                          (selectedLogo: any, logoIndex: any) => (

                            <OrganizationUnitLogoComponent
                              selectedBrand={selectedBrand}
                              logoIndex={logoIndex}
                              changeLogoImage={changeLogoImage}
                              deleteselectedLogo={deleteselectedLogo}
                              handleClose={handleClose}
                              handleOpen={handleOpen}
                              itemIndex={index}
                              onFormLogoItemChange={onFormLogoItemChange}
                              openConfirmationLogo={openConfirmationLogo}
                              selectedLogo={selectedLogo}
                              faviconSize={faviconSize}
                              logoBackground={logoBackground}
                              getIsLogoRecordDeletable={getIsLogoRecordDeletable} />

                          )
                        )}
                      </div>


                    }
                    expandedPanel="logo"
                    headerTitle="Logo Info"
                  />
                </div>
                <div className='col-span-full'>
                  <AccordionContainer
                    child={

                      <div>
                        {_.map(
                          selectedBrand?.Favicons,
                          (selectedFavIcon: any, index: any) => (

                            <OrganizationUnitFavIconComponent
                              selectedBrand={selectedBrand}
                              index={index}
                              changeFavImage={changeFavImage}
                              deleteselectedFavIcon={deleteselectedFavIcon}
                              handleClose={handleClose}
                              handleOpen={handleOpen}
                              itemIndex={index}
                              onFormFavItemChange={onFormFavItemChange}
                              openConfirmationFav={openConfirmationFav}
                              selectedFavIcon={selectedFavIcon}
                              faviconSize={faviconSize}
                              logoBackground={logoBackground}
                              getIsFavRecordDeletable={getIsFavRecordDeletable}
                            />
                          )
                        )}
                      </div>

                    }
                    expandedPanel="FavInfo"
                    headerTitle="Fav Info"
                  />
                </div>
                <div className='col-span-full'>
                  <AccordionContainer
                    child={

                      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>


                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                          <div>
                            <InputLabelContainer label="Color" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.PrimaryColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'PrimaryColor',
                                  idx: index
                                });
                              }} /></div>
                          <div>
                            <InputLabelContainer label="BackgroundColor" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.PrimaryBackgroundColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'PrimaryBackgroundColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <InputContainer
                            label="BackgroundImage"
                            labelField="BackgroundImage"
                            onValueChange={(event: any, newValue: any) => {
                              onFormItemBrandChange({
                                value: event.target.value,
                                field: 'PrimaryBackgroundImage',
                                idx: index
                              });
                            }}
                            type="text"
                            value={selectedBrand?.PrimaryBackgroundImage}
                          />
                        </div>


                      </div>

                    }
                    expandedPanel="ColorInfo"
                    headerTitle="Primary Info"
                  />
                </div>
                <div className='col-span-full'>
                  <AccordionContainer
                    child={

                      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>



                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                          <div>
                            <InputLabelContainer label="Color" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.SecondaryColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'SecondaryColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <div>
                            <InputLabelContainer label="BackgroundColor" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.SecondaryBackgroundColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'SecondaryBackgroundColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <InputContainer
                            label="BackgroundImage"
                            labelField="BackgroundImage"
                            onValueChange={(event: any, newValue: any) => {
                              onFormItemBrandChange({
                                value: event.target.value,
                                field: 'SecondaryBackgroundImage',
                                idx: index
                              });
                            }}
                            type="text"
                            value={selectedBrand?.SecondaryBackgroundImage}
                          />
                        </div>


                      </div>

                    }
                    expandedPanel="ColorInfo"
                    headerTitle="Secondary Info"
                  /></div>
                <div className='col-span-full'>
                  <AccordionContainer
                    child={

                      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>


                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                          <div>
                            <InputLabelContainer label="Color" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.TertiaryColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'TertiaryColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <div>
                            <InputLabelContainer label="BackgroundColor" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.TertiaryBackgroundColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'TertiaryBackgroundColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <InputContainer
                            label="BackgroundImage"
                            labelField="BackgroundImage"
                            onValueChange={(event: any, newValue: any) => {
                              onFormItemBrandChange({
                                value: event.target.value,
                                field: 'TertiaryBackgroundImage',
                                idx: index
                              });
                            }}
                            type="text"
                            value={selectedBrand?.TertiaryBackgroundImage}
                          />
                        </div>



                      </div>

                    }
                    expandedPanel="ColorInfo"
                    headerTitle="Teritary Info"
                  />
                </div>
                <div className='col-span-full'>
                  <AccordionContainer
                    child={

                      <div className=' shadow-card border-2 rounded-lg mb-4 p-2'>


                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                          <div>
                            <InputLabelContainer label="Color" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.GhostColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'GhostColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <div>
                            <InputLabelContainer label="BackgroundColor" />
                            <input

                              type="color"
                              className="h-10 w-56"
                              value={selectedBrand?.GhostBackgroundColor}
                              onChange={(event: any) => {
                                onFormItemBrandChange({
                                  value: event.target.value,
                                  field: 'GhostBackgroundColor',
                                  idx: index
                                });
                              }} />
                          </div>
                          <InputContainer
                            label="BackgroundImage"
                            labelField="BackgroundImage"
                            onValueChange={(event: any, newValue: any) => {
                              onFormItemBrandChange({
                                value: event.target.value,
                                field: 'GhostBackgroundImage',
                                idx: index
                              });
                            }}
                            type="text"
                            value={selectedBrand?.GhostBackgroundImage}
                          />
                        </div>


                      </div>


                    }
                    expandedPanel="ColorInfo"
                    headerTitle="Ghost Info"
                  />
                </div>
              </div>
            }
            expandedPanel="BrandMappings"
            headerTitle="Brand Mappings"

          />
        )
      )}
      <div className='flex w-full justify-end items-end'>

        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}

          type="submit"
        >
          Save
        </button>
      </div>
    </>

  )
}
export default AccoutBrandInfoComponent;
